module.exports = __webpack_public_path__ + "img/buttonruim.1c1452ff.png";